import type { ReactNode } from "react";

/** G-9.2 kit: calm empty state — message first, optional single action. */
export function EmptyState({
  title,
  message,
  action,
}: {
  title: string;
  message?: string;
  action?: ReactNode;
}) {
  return (
    <div className="kit-empty">
      <strong className="kit-empty-title">{title}</strong>
      {message ? <p className="kit-empty-message">{message}</p> : null}
      {action ?? null}
    </div>
  );
}
